import {Checkbox, Flex, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {resultStore} from "../../../store/admissions/admissionStore";
import {stepsStore} from "../../../store/admissions/stepperStore";
import {categories} from "../model/categories";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default function Step7() {
    const {stepsData, setStepsData} = stepsStore();
    const {result, setResult} = resultStore();
    const [selectDisable, setSelectDisable] = useState(false);
    const [selectNotAnyDisable, setSelectNotAnyDisable] = useState(false);
    const [selectedCount, setSelectedCount] = useState(0);
    const {xl} = useBreakpoint()

    useEffect(() => {

        if (result.kindsLevelFormation === "000000008" || result.kindsLevelFormation === "000000003") {
            setStepsData({
                currentStep: stepsData.currentStep + 1,
                completedSteps: [...stepsData.completedSteps],
                skippedSteps: [...stepsData.skippedSteps, stepsData.currentStep],
                nextStep: false,
                backStep: stepsData.backStep + 1,
                forwardStep: 0
            })
            setResult(
                {
                    ...result,
                    categories: []
                }
            )
        }

        if (!result.categories) {
            setResult({
                ...result,
                categories: categories.get(result.kindsLevelFormation)?.reduce((acc, current) => ({
                    ...acc,
                    [current.code]: false
                }), {}),
            })
        } else {
            setStepsData({...stepsData, nextStep: true})
        }
    }, []);

    return (
        <Flex vertical style={{width: '100%'}} justify={"center"} align={"center"} gap={24}>
            <Flex vertical justify={"center"} align={"center"}>
                <Typography.Text strong style={{fontSize: 20}}>Я отношусь к категории</Typography.Text>
                <Typography.Text>(можно выбрать несколько категорий)</Typography.Text>
            </Flex>
            <Flex vertical gap={16} style={{width: xl ? '50%' : '100%'}}>
                {categories.get(result.kindsLevelFormation)?.map((item, index) => (
                    <Checkbox
                        defaultChecked={result.categories !== null && result.categories[item.code]}
                        disabled={(selectDisable && item.code !== "notany") || (selectNotAnyDisable && item.code === "notany") || (result.categories !== null && result.categories["notany"] && item.code !== "notany")}
                        key={item.code}
                        onChange={(event) => {
                            setResult({
                                ...result,
                                categories: {
                                    ...result.categories,
                                    [item.code]: event.target.checked
                                }
                            })
                            if (item.code === "notany") {
                                setSelectDisable(event.target.checked);
                            } else {
                                setSelectedCount(selectedCount + (event.target.checked ? 1 : -1));
                                if (event.target.checked && selectedCount === 0) {
                                    setSelectNotAnyDisable(true);
                                } else if (!event.target.checked && selectedCount === 1) {
                                    setSelectNotAnyDisable(false);
                                }
                            }
                            setStepsData({...stepsData, nextStep: true})
                        }}>{item.display}</Checkbox>
                ))}
            </Flex>
        </Flex>
    )
}